'use client';

import { useEffect, useState } from 'react';
import Link from './Link';

/**
 * Cookie 同意通知组件
 * 符合 GDPR 要求，告知用户网站使用 cookies
 */
export default function CookieConsent() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    // 检查用户是否已经做出选择
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      // 延迟显示，避免影响用户体验
      const timer = setTimeout(() => {
        setShow(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    localStorage.setItem('cookie-consent-date', new Date().toISOString());
    setShow(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookie-consent', 'declined');
    localStorage.setItem('cookie-consent-date', new Date().toISOString());
    setShow(false);
    // 注意：即使拒绝，必要的认证 cookies 仍然需要设置
    // 但可以禁用非必要的 cookies（如分析 cookies）
  };

  if (!show) return null;

  return (
    <div
      className="fixed right-0 bottom-0 left-0 z-50 bg-white p-4 shadow-lg md:right-auto md:bottom-4 md:left-4 md:max-w-md md:rounded-lg dark:bg-gray-800"
      role="dialog"
      aria-labelledby="cookie-consent-title"
      aria-describedby="cookie-consent-description"
    >
      <div className="flex flex-col gap-3">
        <div>
          <h3
            id="cookie-consent-title"
            className="text-lg font-semibold text-gray-900 dark:text-gray-100"
          >
            🍪 Cookie 使用通知
          </h3>
          <p
            id="cookie-consent-description"
            className="mt-1 text-sm text-gray-600 dark:text-gray-400"
          >
            我们使用 cookies 来提供更好的用户体验和网站功能。这包括：
          </p>
          <ul className="mt-2 ml-4 list-disc text-sm text-gray-600 dark:text-gray-400">
            <li>认证和安全（必要的）</li>
            <li>网站功能（必要的）</li>
            {process.env.NEXT_UMAMI_ID && <li>网站分析（可选）</li>}
          </ul>
          <p className="mt-2 text-xs text-gray-500 dark:text-gray-500">
            继续使用本网站即表示您同意使用 cookies。{' '}
            <Link
              href="/privacy"
              className="text-primary-500 hover:text-primary-600 dark:text-primary-400 underline"
            >
              了解更多
            </Link>
          </p>
        </div>
        <div className="flex flex-col gap-2 sm:flex-row">
          <button
            onClick={handleAccept}
            className="bg-primary-500 hover:bg-primary-600 focus:ring-primary-500 flex-1 rounded-lg px-4 py-2 text-sm font-medium text-white transition-colors focus:ring-2 focus:ring-offset-2 focus:outline-none dark:focus:ring-offset-gray-800"
            aria-label="接受 Cookie 使用"
          >
            接受
          </button>
          <button
            onClick={handleDecline}
            className="focus:ring-primary-500 flex-1 rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-50 focus:ring-2 focus:ring-offset-2 focus:outline-none dark:border-gray-600 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600 dark:focus:ring-offset-gray-800"
            aria-label="拒绝 Cookie 使用"
          >
            拒绝
          </button>
        </div>
      </div>
    </div>
  );
}
